import React from "react";
import { useNavigate } from "react-router-dom";
import { ShortcutsIcon } from "~/assets/svg/SidebarMenuIcon";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";
import useAlert from "~/common/hooks/useAlert";

const SubMenuItem = ({ active, disabled, title, engTitle, id, handleClick }) => {
	const { i18n } = useTranslation();
	const classString = `${active}${disabled ? " disabled" : ""}`;
	return (
		<li name={id} className={classString} onClick={!disabled ? handleClick : null}>
			{i18n.language === "ko" ? title : engTitle}
		</li>
	);
};

const SubMenu = ({ list, currentMenu, currentType, user, selectedMainMenu }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const [
		{
			sidebar: { authMap },
		},
	] = useGlobalStore();

	const currentFormPath = authMap?.main?.apply?.form;

	const [showAuthAlert, AuthAlert] = useAlert();

	const subMenuList = () => {
		return list?.reduce((acc, menu) => {
			if (menu.viewMode === true) {
				const title = menu.title;
				const engTitle = menu.engTitle;
				const id = menu?.id;
				const active = id === currentMenu && "active";
				const element = (
					<SubMenuItem
						key={acc.length}
						handleClick={() => {
							/** 현재 Path 와 동일한 경우 새로고침 **/
							if (menu.to === window.location.pathname) {
								navigate(0);
							}

							navigate(menu.to);
						}}
						disabled={menu.auth === "none"}
						{...{
							active,
							title,
							engTitle,
							id,
						}}
					/>
				);
				return acc.concat(element);
			} else {
				return acc;
			}
		}, []);
	};

	if (!list || list.length === 0) return <></>;

	return (
		<ul className="l__subMenu">
			{currentType === "myPage" && (
				<li className="company-info">
					<dl>
						<dt className="company-name">{user.company.name}</dt>
						<dd className="account-role">
							{user.info.role === "admin"
								? t("common.components.SideBar.SubMenu.admin")
								: user.info.role === "user"
								? t("common.components.SideBar.SubMenu.user")
								: t("common.components.SideBar.SubMenu.manager")}
						</dd>
					</dl>
					<dl className="license">
						<dt>{t("common.components.SideBar.SubMenu.license")}</dt>
						{/* <dd>{user.company.license.toUpperCase()}</dd> */}
						<dd>{user.company.license}</dd>
					</dl>
				</li>
			)}
			{subMenuList()}
			{selectedMainMenu?.id === "apply" && (
				<button
					className="btn__outline"
					onClick={() => {
						if (currentFormPath === "edit" || currentFormPath === "view") {
							window.open("/applyForm/view", "_blank");
							return;
						}
						showAuthAlert();
					}}
				>
					{t("common.components.SideBar.SubMenu.goApply")}
					<ShortcutsIcon />
				</button>
			)}
			<AuthAlert
				message={
					<>
						권한이 없습니다. <br />
						관리자에게 문의하세요.
					</>
				}
				type="warning"
				confirm="확인"
			/>
		</ul>
	);
};

export default SubMenu;
